import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowRight, Calendar, User } from "lucide-react";
import api, { API } from "@/lib/api";
import Layout from "@/components/Layout";

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  } catch (_e) {
    return "";
  }
}

export default function BlogList() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    let cancel = false;
    api
      .get("/public/blog")
      .then(({ data }) => { if (!cancel) setPosts(data); })
      .catch(() => { if (!cancel) setPosts([]); });
    return () => { cancel = true; };
  }, []);

  return (
    <Layout variant="public">
      <section className="border-b-2 border-black bg-[#FEF3C7]" data-testid="blog-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-700 mb-2">Careers Blog</div>
          <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Stories, guides<br />and updates from the careers team.
          </h1>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {posts === null ? (
          <div className="flex items-center justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#C8102E]" /></div>
        ) : posts.length === 0 ? (
          <div className="brut-card-static p-12 text-center" data-testid="blog-empty">
            <div className="font-display text-3xl font-black mb-2">No posts yet</div>
            <p className="text-zinc-700 font-medium">Check back soon — the careers team is working on something.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="blog-grid">
            {posts.map((p) => (
              <Link to={`/blog/${p.id}`} key={p.id} className="block group brut-card p-0 overflow-hidden" data-testid={`blog-card-${p.id}`}>
                {p.cover ? (
                  <div className="aspect-video border-b-2 border-black overflow-hidden bg-zinc-100">
                    <img src={`${API}/files/${p.cover.id}`} alt="" className="w-full h-full object-cover object-center" />
                  </div>
                ) : (
                  <div className="aspect-video border-b-2 border-black bg-[#FEF3C7] flex items-center justify-center">
                    <span className="font-display font-black text-6xl text-[#C8102E]">B</span>
                  </div>
                )}
                <div className="p-6">
                  <h3 className="font-display font-bold text-xl mb-2 leading-tight">{p.title}</h3>
                  {p.excerpt && <p className="text-sm text-zinc-700 line-clamp-3 mb-3">{p.excerpt}</p>}
                  <div className="flex items-center justify-between text-xs text-zinc-600 font-bold pt-2 border-t-2 border-black">
                    <span className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5" />{formatDate(p.publish_at || p.published_at)}</span>
                    <span className="flex items-center gap-1.5"><User className="h-3.5 w-3.5" />{p.author_name}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
